'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { usePathname } from 'next/navigation';
import { CustomLink } from '@/app/_components/CustomLink';
import { DONATION_ROUTES, PARTNER_SUB_DOMAIN_LIST } from '@/constants';
import { useCheckKakaobank } from '@/hooks/useCheckKakaobank';
import { useIsOutsideWelloChannel } from '@/hooks/useIsOutsideWelloChannel';
import { usePartnerChromeClassName } from '@/hooks/usePartnerChromeClassName';
import { useDeviceInfoStore } from '@/stores/DeviceStore';
import { DONATION_DESKTOP_HEADER_HEIGHT, DONATION_SUB_HEADER_HEIGHT } from '../../constants';
import { Agencies } from './Agencies';
import { RegionFinderDropdown } from './RegionFinderDropdown';
export const DonationSubHeader = () => {
  const $ = _c(33);
  const partnerChromeClassName = usePartnerChromeClassName();
  const pathname = usePathname();
  const isKakaobank = useCheckKakaobank();
  const isPartnersHidden = useIsOutsideWelloChannel();
  const isPartnerChannel = useDeviceInfoStore(_temp);
  let t0;
  if ($[0] !== partnerChromeClassName) {
    t0 = cn(partnerChromeClassName, "sticky z-10 w-full bg-Gray-white mobile:hidden tablet:hidden");
    $[0] = partnerChromeClassName;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      top: DONATION_DESKTOP_HEADER_HEIGHT,
      height: DONATION_SUB_HEADER_HEIGHT
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <li><RegionFinderDropdown /></li>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = DONATION_ROUTES.GIFTS.pathname === pathname;
  let t4;
  if ($[4] !== t3) {
    t4 = <SubLink href={DONATION_ROUTES.GIFTS.pathname} isSelected={t3}>답례품</SubLink>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isPartnerChannel || $[7] !== pathname) {
    t5 = isPartnerChannel ? null : <SubLink href={DONATION_ROUTES.GIFT_TRIAL.pathname} isSelected={DONATION_ROUTES.GIFT_TRIAL.pathname === pathname} isNew={true}>체험단</SubLink>;
    $[6] = isPartnerChannel;
    $[7] = pathname;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== isPartnersHidden || $[10] !== pathname) {
    t6 = !isPartnersHidden && <SubLink href={DONATION_ROUTES.PARTNERS.pathname} isSelected={pathname.startsWith(DONATION_ROUTES.PARTNERS.pathname)} isNew={true}>파트너스</SubLink>;
    $[9] = isPartnersHidden;
    $[10] = pathname;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = DONATION_ROUTES.MY_ETC_EVENT.pathname === pathname;
  let t8;
  if ($[12] !== t7) {
    t8 = <SubLink href={DONATION_ROUTES.MY_ETC_EVENT.pathname} isSelected={t7} isNew={true}>이벤트</SubLink>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = DONATION_ROUTES.HOMETOWNS_BUSINESS.pathname === pathname;
  let t10;
  if ($[14] !== t9) {
    t10 = <SubLink href={DONATION_ROUTES.HOMETOWNS_BUSINESS.pathname} isSelected={t9}>지정기부사업</SubLink>;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = DONATION_ROUTES.GUIDE.pathname === pathname;
  let t12;
  if ($[16] !== t11) {
    t12 = <SubLink href={DONATION_ROUTES.GUIDE.pathname} isSelected={t11}>고향사랑기부란?</SubLink>;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t10 || $[19] !== t12 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6 || $[23] !== t8) {
    t13 = <ul className="flex items-center gap-12">{t2}<li className="flex items-center">{t4}{t5}{t6}{t8}{t10}{t12}</li></ul>;
    $[18] = t10;
    $[19] = t12;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t8;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== isKakaobank) {
    t14 = !isKakaobank && <Agencies />;
    $[25] = isKakaobank;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t13 || $[28] !== t14) {
    t15 = <nav className="mx-auto flex h-full max-w-screen-xl items-center justify-between px-40">{t13}{t14}</nav>;
    $[27] = t13;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t0 || $[31] !== t15) {
    t16 = <div data-goods-home-sub-header={true} className={t0} style={t1}>{t15}</div>;
    $[30] = t0;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  return t16;
};
const SubLink = t0 => {
  const $ = _c(10);
  const {
    href,
    isSelected,
    isNew: t1,
    children
  } = t0;
  const isNew = t1 === undefined ? false : t1;
  const t2 = isSelected ? "page" : undefined;
  const t3 = isSelected ? "font-700 text-Gray-800" : "font-600 text-Gray-550 hover:text-Gray-900";
  let t4;
  if ($[0] !== t3) {
    t4 = cn("flex h-56 items-center px-24 transition-colors typo-body3", t3);
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== isNew) {
    t5 = isNew ? <NewBadge /> : null;
    $[2] = isNew;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== children || $[5] !== href || $[6] !== t2 || $[7] !== t4 || $[8] !== t5) {
    t6 = <CustomLink href={href} aria-current={t2} className={t4}>{children}{t5}</CustomLink>;
    $[4] = children;
    $[5] = href;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};

//* 디자인 라이브러리 Badge(new) — 공용 SvgNewRed와 색·글자 굵기가 달라 시안 경로를 그대로 쓴다
const NewBadge = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg role="img" aria-label={"\uC0C8 \uBA54\uB274"} viewBox="0 0 16 16" className="ml-4 size-16 shrink-0 text-O-500"><circle cx="8" cy="8" r="8" fill="currentColor" /><path d="M10.9489 11.5359H9.67818L6.57044 7.04351H6.51865V11.5359H5.05111V4.46409H6.34254L9.42611 8.95304H9.48826V4.46409H10.9489V11.5359Z" fill="white" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(state) {
  return PARTNER_SUB_DOMAIN_LIST.some(partner => partner === state.subDomain);
}